//=================================================
//    summary: DCP Assignment 列表 -- Hook
//
//    remarks: 000 Tim 2021/11/11 Create
//             001 Tim 2021/12/23 Fix Bug DueDate顯示錯誤
//                                加入 PaintedMe流程
//             002 Tim 2020/12/27 搬移到 Tool 改成 Popup Windows
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssAssignReport from './AssignReport.module.scss'

import RunningPieChart from '../RunningPieChart/RunningPieChart'
import BulletinMsgBox from '../../Home/Units/BulletinMsgBox/BulletinMsgBox'

import AssignmentAnswerWindow from '../AssignmentAnswerWindow/AssignmentAnswerWindow'
import {GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'


// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mobjShowComponentParam = null

let mobjClassAssignmentDetail = null
let mobjDisplay = null
let marrScoreData4List = []
let mstrLeftSubSubTitle = ""
let mobjRPC = {
    "ScoredCount": 0,
    "ListCount": 0
}
let mobjAuthorizedSubscription = null
let mobjNoAuthorizedParam = null
let mblnDirty = false
// #endregion Member Variables

// #region Enumeration
const ReportStatusEnum = {
    "NA": 0,
    "ScoreIt": 1,
    "Result": 2
}
// #endregion Enumeration


const COMP_NAME = "AssignReport"

function AssignReport(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [percentage4RPC, setPercentage4RPC] = useState(-1)
    const [isShowBulletinMsgBox, setIsShowBulletinMsgBox] = useState(false)
    const [isShowAssignmentAnswerWindow, setIsShowAssignmentAnswerWindow] = useState(false)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        let objPracticeLU = window.garrPracticeLU.find(Unit => parseInt(Unit.LUCatSeqNo) === parseInt(props.Arguments.AssignmentSource.LUCatSeqNo))
        let intLessonSeqNo = parseInt(props.Arguments.AssignmentSource.LessonID) % 100
        mstrLeftSubSubTitle = window.gAppUI.LBL_Lesson + ' ' + intLessonSeqNo + ' - ' + objPracticeLU.DisplayName

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            mobjRPC = {
                "ScoredCount": 0,
                "ListCount": 0
            }
            mblnDirty = false
            setPercentage4RPC(-1)
            setUpdateDataTime(0)
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 返回 按鈕
    remarks: 000 Tim 2021/11/11 Create
             001 Tim 2021/12/27 通知外層 關閉自己
    ===========================================*/
    function BackOnTapHandler()
    {
        console.log(COMP_NAME +  ".BackOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        

        let objCallbackData = {
            "Action": "CloseShowAssignReport",
            "Dirty": mblnDirty
        }
        props.CallbackRef(objCallbackData)
    } // end of BackOnTapHandler

    /*===========================================
    summary: 點選 訊息
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function MessageOnTapHandler()
    {
        console.log(COMP_NAME + ".MessageOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        mobjShowComponentParam = {
            "Message": mobjDisplay.AssigmentInfoMsg
        }

        setIsShowBulletinMsgBox(true)
    } // end of MessageOnTapHandler

    /*===========================================
    summary: 點選 狀態按鈕
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function StatusButtonOnTapHandler(ScoreData, ScoreIndex)
    {
        console.log(COMP_NAME + ".StatusButtonOnTapHandler: ", ScoreData)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let intAssignReportStatus = 0
        if (
            (typeof(ScoreData.Score) === 'undefined') ||
            (ScoreData.Score === null)
            )
        {
            intAssignReportStatus = window.gAssignReportStatusEnum.TeacherScore
        }
        else
        {
            intAssignReportStatus = window.gAssignReportStatusEnum.TeacherResult
        }

        let strLessonID = props.Arguments.AssignmentSource.LessonID.toString().PadLeft(5)          // 左邊補零 Format "01001"
        
        // 這邊如果沒有授權 也要跑一下 NoAuthorizedProcess
        let intBookSeqNo = window.Globals.GetBookSeqNoFromLessonID(strLessonID)
        let strBookSeqNo = intBookSeqNo.toString().PadLeft(2)

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(strLessonID))
        {
            blnExpired = false;
        }
        else 
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo))
        } 

        let objAssignmentData = {
            "AssignID": ScoreData.AssignID,
            "LessonID": strLessonID,
            "StudentID": ScoreData.StudentAccID,
            "LUCatSeqNo": props.Arguments.AssignmentSource.LUCatSeqNo,
            "AssignedClassID": window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID,
            "AssignReportStatus": intAssignReportStatus,
            "ScoreIndex": ScoreIndex
        }

        if (!blnExpired)
        {
            // 有授權
            // 前往 老師改考卷 or 老師看考卷
            mobjShowComponentParam = {
                "AssignmentData": objAssignmentData
            }

            console.log(COMP_NAME + ".StatusButtonOnTapHandler mobjShowComponentParam: ", mobjShowComponentParam)

            setIsShowAssignmentAnswerWindow(true)
        }
        else
        {
            // 沒授權
            // 註冊 重新取得授權後流程
            RegisterReGetAuthorizedAfterProcess()

            mobjNoAuthorizedParam = {
                "AssignmentData": objAssignmentData,
                "BookSeqNo": strBookSeqNo,
                "LessonID": strLessonID
            }
            
            NoAuthorizedProcess(window.gSession.App.BookCatID, strBookSeqNo, strLessonID, props.Arguments.AssignmentSource.LUCatSeqNo)
        }
    } // end of StatusButtonOnTapHandler
    // #endregion OnTapHandler
    
    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2021/12/27 改呼叫 上一層 去執行
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2021/12/27 改呼叫 上一層 去執行
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/11/12 Create
             001 Tim 2021/12/27 改呼叫 上一層 去執行
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback
    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowBulletinMsgBox")
        {
            setIsShowBulletinMsgBox(false)
        }
        else if (CallbackObj.Action === "CloseShowAssignmentAnswerWindow")
        {
            mobjShowComponentParam = null
            setIsShowAssignmentAnswerWindow(false)
        }
        else if (CallbackObj.Action === "SubmitSuccessAssignmentAnswerWindow")
        {
            ResetScoreData4SubmitSuccess(parseInt(CallbackObj.AssignID), parseInt(CallbackObj.Score))

            mblnDirty = true
            mobjShowComponentParam = null
            setIsShowAssignmentAnswerWindow(false)
            setUpdateDataTime(new Date().getTime())
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region AlertCallBack
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2020/12/27 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            let objCallbackData = {
                "Action": "NoAuthorizedGoToSubscription",
                "AuthorizedSubscription": mobjAuthorizedSubscription
            }
            props.CallbackRef(objCallbackData)
        }
        else
        {
            // 取消的話，清空資料
        }
        mobjAuthorizedSubscription = null
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack
    // #endregion AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        // 到後端 取得 資料
        mobjCallParam = {
            "NewAssignmentID": parseInt(props.Arguments.AssignmentSource.NewAssignmentID)
        }
        GetClassNewAssignmentDetail()
    } // end of PaintedMe

    /*===========================================
    summary: 註冊 重新取得 授權後流程
    remarks: 000 Tim 2021/12/27 Create
    ===========================================*/
    function RegisterReGetAuthorizedAfterProcess ()
    {
        let objCallbackData = {
            "Action": "RegisterReGetAuthorizedAfterProcess",
            "Function": ReGetAuthorizedAfterProcess
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterReGetAuthorizedAfterProcess

    /*===========================================
    summary: 重新取得 授權後流程
    remarks: 000 Tim 2021/12/27 Create
    ===========================================*/
    function ReGetAuthorizedAfterProcess ()
    {
        // mobjNoAuthorizedParam = {
        //     "AssignmentData": objAssignmentData,
        //     "BookSeqNo": strBookSeqNo,
        //     "LessonID": strLessonID
        // }
        
        let strBookSeqNo = mobjNoAuthorizedParam.BookSeqNo
        let strLessonID = mobjNoAuthorizedParam.LessonID

        let blnExpired = true
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(strLessonID))
        {
            blnExpired = false;
        }
        else 
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo))
        }

        if (!blnExpired)
        {
            // 有授權
            // 前往 老師改考卷 or 老師看考卷
            mobjShowComponentParam = {
                "AssignmentData": mobjNoAuthorizedParam.AssignmentData
            }

            console.log(COMP_NAME + ".ReGetAuthorizedAfterProcess mobjShowComponentParam: ", mobjShowComponentParam)

            setIsShowAssignmentAnswerWindow(true)
        }
        else
        {
            // 沒授權
            console.log(COMP_NAME + ".ReGetAuthorizedAfterProcess NoAuthorized")
        }

        mobjNoAuthorizedParam = null
    } // end of ReGetAuthorizedAfterProcess

    /*===========================================
    summary: 初始化班級評分詳細資料
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function InitClassAssignmentDetail()
    {
        console.log(COMP_NAME + ".InitClassAssignmentDetail mobjClassAssignmentDetail", mobjClassAssignmentDetail)
        let intIndex = 0
        let intCount = mobjClassAssignmentDetail.ScoreList.length
        
        let arrScoreData4List = []
        let intScoredCount = 0
        let intTotalScore = 0
        let objScoreItem = null
        let intScoreItemStatus = ReportStatusEnum.NA        //0:未考試 1:考完沒打分數 2:考完打完
        let fltAvgScore = 0.0                               //小數點兩位 取四捨五入
        let strAvgScoreFormatted = window.gAppUI.LBL_TBD

        let datStartLocal = null
        let datDueLocal = null

        let strMessage = ''
        let objDate = null
        let strStartDate = ''
        let strDueDate = ''
        let strStartTime = ''
        let strDueTime = ''

        let intCompletion = -1

        //  == 整理需要處理的變數 BEGIN ==
        if (
            (typeof(mobjClassAssignmentDetail.Message) !== 'undefined') &&
            (mobjClassAssignmentDetail.Message !== null)
            )
        {
            strMessage = mobjClassAssignmentDetail.Message
        }

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            // Total Score
            if (mobjClassAssignmentDetail.ScoreList[intIndex].Score !== null)
            {  
                intTotalScore += parseFloat(mobjClassAssignmentDetail.ScoreList[intIndex].Score)
            }

            // Scored Count
            if (mobjClassAssignmentDetail.ScoreList[intIndex].TestedTime !== null)
            {
                intScoredCount++
            }

            console.log("TestedTime: ", mobjClassAssignmentDetail.ScoreList[intIndex].TestedTime)
            // status 0:未考試 1:考完沒打分數 2:考完打完
            if (mobjClassAssignmentDetail.ScoreList[intIndex].TestedTime === null)
            {
                intScoreItemStatus = ReportStatusEnum.NA
            }
            else if (mobjClassAssignmentDetail.ScoreList[intIndex].Score === null)
            {
                intScoreItemStatus = ReportStatusEnum.ScoreIt
            }
            else
            {
                intScoreItemStatus = ReportStatusEnum.Result
            }

            objScoreItem = {
                "StudentAccID": mobjClassAssignmentDetail.ScoreList[intIndex].StudentAccID,
                "AssignID": mobjClassAssignmentDetail.ScoreList[intIndex].AssignID,
                "UserName": window.Globals.FormateDisplayName(mobjClassAssignmentDetail.ScoreList[intIndex].FirstName, mobjClassAssignmentDetail.ScoreList[intIndex].LastName, mobjClassAssignmentDetail.ScoreList[intIndex].LoginName),
                "Score": mobjClassAssignmentDetail.ScoreList[intIndex].Score,
                "TestedTime": mobjClassAssignmentDetail.ScoreList[intIndex].TestedTime,
                "Status": intScoreItemStatus
            }

            arrScoreData4List.push(objScoreItem)
        } // end of for (intIndex = 0;

        // 開始時間         // Server讀出來的時間 轉 顯示時間
        datStartLocal = mobjClassAssignmentDetail.StartDate.ToUTC()
        objDate = GetFormatDisplayDateObject(datStartLocal.ToBCLocalTimeString())
        strStartDate = objDate.Date
        strStartTime = objDate.Time

        // 截止時間         // Server讀出來的時間 轉 顯示時間
        datDueLocal = mobjClassAssignmentDetail.DueDate.ToUTC()
        objDate = GetFormatDisplayDateObject(datDueLocal.ToBCLocalTimeString())
        strDueDate = objDate.Date
        strDueTime = objDate.Time

        if (intScoredCount > 0)
        {
            // 平均分數 取小數點兩位 取四捨五入
            fltAvgScore = (Math.floor(((intTotalScore / intScoredCount) + 0.005) * 100) / 100).toFixed(2)
            strAvgScoreFormatted = fltAvgScore.toString()
        }
        //  == 整理需要處理的變數 END ==

        // == 塞入撈取出來的數值 BEGIN ==
        mobjDisplay = {
            "AssigmentInfoName": mobjClassAssignmentDetail.Name,
            "StartDate": strStartDate,
            "DueDate": strDueDate,
            "StartTime": strStartTime,
            "DueTime": strDueTime,
            "LessonName": props.Arguments.AssignmentSource.LessonName,
            "AssigmentInfoMsg": strMessage,
            "AvgScoreFormatted": strAvgScoreFormatted           
        }

        console.log("mobjDisplay: ", mobjDisplay)
        // == 塞入撈取出來的數值 END ==

        marrScoreData4List = arrScoreData4List

        setUpdateDataTime(new Date().getTime())

        mobjRPC.ScoredCount = intScoredCount
        mobjRPC.ListCount = intCount
        intCompletion = intScoredCount / intCount * 100

        console.log("mobjRPC: ", mobjRPC)
        console.log("intCompletion: ", intCompletion)
        console.log("InitClassAssignmentDetail End marrScoreData4List: ", marrScoreData4List)
        
        setPercentage4RPC(intCompletion)
    } // end of InitClassAssignmentDetail

    /*===========================================
    summary: 取得 格式化 顯示的 日期 物件
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetFormatDisplayDateObject (DateString)
    {
        let objDate = {
            "Date": "",
            "Time": ""
        }

        let strDateTmp = ''
        let arrDateTmp = []
        let arrTimeTmp = []

        strDateTmp = DateString.replace(/-/g, '/')
        arrDateTmp = strDateTmp.split(" ")
        objDate.Date = arrDateTmp[0]
        arrTimeTmp = arrDateTmp[1].split(":")
        objDate.Time = arrTimeTmp[0] + ":" + arrTimeTmp[1]

        return objDate
    } // end of GetFormatDisplayDateObject

    /*===========================================
    summary: 重新設定 ScoreData 顯示資料 
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function ResetScoreData4SubmitSuccess (AssignID, Score)
    {
        let objScoreData = marrScoreData4List.find(ScoreData => parseInt(ScoreData.AssignID) === AssignID)
        objScoreData.Score = Score.toString()
        objScoreData.Status = ReportStatusEnum.Result

        console.log("ResetScoreData4SubmitSuccess End marrScoreData4List: ", marrScoreData4List)
    } // end of ResetScoreData4SubmitSuccess

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/12/27 Create
    ===========================================*/
    function NoAuthorizedProcess (BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": window.gAuthorizedSubscriptionTypeEnum.AssignReport
        }

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 分數顯示 Cls
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetScoreValueCls (Score)
    {            
        let objCls = cssAssignReport.divScoreValueCell
        
        if (
            (typeof(Score) === 'undefined') ||
            (Score === null)
            )
        {
            objCls = cssAssignReport.divScoreValueCellNA
        }

        return objCls
    }  // end of GetScoreValueCls

    /*===========================================
    summary: 取得 狀態按鈕 Cls
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function GetStatusButtonCls (Status)
    {            
        var objCls = cssAssignReport.btnStatus
        
        switch (Status)
        {
            case ReportStatusEnum.ScoreIt:
                objCls = cssAssignReport.btnStatusScoreIt
                break
            case ReportStatusEnum.Result:
                objCls = cssAssignReport.btnStatusResult
                break
            case ReportStatusEnum.NA:
            default:
                objCls = cssAssignReport.btnStatusNA
                break
        }

        return objCls
    }  // end of GetStatusButtonCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 取得 指派考卷詳細資料 完畢
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function GetClassNewAssignmentDetailAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetClassNewAssignmentDetailAfterProcess")

        mobjClassAssignmentDetail = ReturnData
        mobjCallParam = null

        InitClassAssignmentDetail()
    } // end of GetClassNewAssignmentDetailAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得考卷詳細資料
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function GetClassNewAssignmentDetail()
    {        
        let objRetryFuncRef = GetClassNewAssignmentDetail
        
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetClassNewAssignmentDetailCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY
            
            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetClassNewAssignmentDetail)

            let objCallData = {
                "Func": "GetClassNewAssignmentDetail",
                "NewAssignmentID": mobjCallParam.NewAssignmentID
            }
            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetClassNewAssignmentDetail

    /*===========================================
    summary: 取得考卷詳細資料 Callback
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function GetClassNewAssignmentDetailCallback(Return)
    {        
        // Close Loading mask
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetClassNewAssignmentDetail_No
        let strErrorTitle = window.gAppUI.ERR_GetClassNewAssignmentDetail_Title
        let strErrMsg = window.gAppUI.ERR_GetClassNewAssignmentDetail_Msg
        // end of customize
        
        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break;
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetClassNewAssignmentDetailCallback: ErrNo: ", Return.ErrNo)
            console.log("GetClassNewAssignmentDetailCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetClassNewAssignmentDetailCallback Return.Data: ", Return.Data)

            GetClassNewAssignmentDetailAfterProcess(Return.Data)
        }
    } // end of GetClassNewAssignmentDetailCallback
    // #endsregion Web Service

    // #region Render元件
    /*===========================================
    summary: 分數列表 分數 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreStatusValueCell( {ScoreData, ScoreIndex} )
    {        
        let strButton = ""

        switch (ScoreData.Status)
        {
            case ReportStatusEnum.ScoreIt:
                strButton = window.gAppUI.BTN_Score
                break
            case ReportStatusEnum.Result:
                strButton = window.gAppUI.BTN_Result
                break
            case ReportStatusEnum.NA:
            default:
                strButton = window.gAppUI.LBL_NA
                break
        } // end of switch

        return (
            <div className={cssAssignReport.divStatusValueCell}>
                <div className={GetStatusButtonCls(ScoreData.Status)} onClick={() => StatusButtonOnTapHandler(ScoreData, ScoreIndex)}>
                    {strButton}
                </div>
            </div>
        )
    } // end of ComponentScoreStatusValueCell

    /*===========================================
    summary: 分數列表 分數 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreScoreValueCell( {Score} )
    {        
        let strScore = ""

        if (
            (typeof(Score) === 'undefined') ||
            (Score === null)
            )
        {
            strScore = window.gAppUI.LBL_NotScore
        }
        else
        {
            strScore = Score
        }

        return (
            <div className={GetScoreValueCls(Score)}>
                {strScore}
            </div>
        )
    } // end of ComponentScoreScoreValueCell                

    /*===========================================
    summary: 分數列表 標題 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreNameValueCell( {UserName} )
    {        
        return (
            <div className={cssAssignReport.divNameValueCell}>
                {UserName}
            </div>
        )
    } // end of ComponentScoreNameValueCell

    /*===========================================
    summary: 分數列表 標題 列 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentScoreTitleRow()
    {        
        return (
            <div className={cssAssignReport.divScoreTitleRow}>
                <div className={cssAssignReport.divNameTitleCell}>
                    {window.gAppUI.LBL_Name}
                </div>
                <div className={cssAssignReport.divScoreTitleCell}>
                    {window.gAppUI.LBL_Score}
                </div>
                <div className={cssAssignReport.divStatusTitleCell}>
                    {window.gAppUI.LBL_Status}
                </div>
            </div>
        )
    } // end of ComponentScoreTitleRow

    /*===========================================
    summary: 平均分數 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentAverageContent( {AvgScore} )
    {        
        return (
            <div className={cssAssignReport.divAverageContent}>
                <div className={cssAssignReport.divAverageTitle}>
                    {window.gAppUI.LBL_AverageScore}
                </div>
                <div className={cssAssignReport.divAverageScore}>
                    {AvgScore}
                </div>
            </div>
        )
    } // end of ComponentAverageContent                

    /*===========================================
    summary: 分隔 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentDelimiter()
    {        
        return (
            <div className={cssAssignReport.divDelimiter}>
                . . . .
            </div>
        )
    } // end of ComponentDelimiter 

    /*===========================================
    summary: Date Content 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentDateContent( {Date, Time} ) 
    {        
        return (
            <div className={cssAssignReport.divDateContent}>
                <div className={cssAssignReport.divDateText}>
                    {Date}
                </div>

                <div className={cssAssignReport.divDateLine}/>

                <div className={cssAssignReport.divTimeText}>
                    {Time}
                </div>
            </div>
        )
    } // end of ComponentDateContent 

    /*===========================================
    summary: Date Title Area 顯示Component
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function ComponentDateTitleArea( {Title} ) 
    {        
        return (
            <div className={cssAssignReport.divDateTitleArea}>
                <div className={cssAssignReport.divDateIcon}/>
                <div className={cssAssignReport.divDateTitleText}>
                    {Title}
                </div>
            </div>
        )
    } // end of ComponentDateTitle 
                
    /*===========================================
    summary: Message Title 顯示Component
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function ComponentLeftTitleAndMessage( {Title, Message} ) 
    {   
        return(
            <>
                <div className={cssAssignReport.divReportIcon}/>
                <div className={cssAssignReport.divNameArea} onClick={() => MessageOnTapHandler()}>
                    <div className={cssAssignReport.divNameText}>
                        {Title}
                    </div>
                    <div className={cssAssignReport.divMessageText}>
                        {Message}
                    </div>
                </div>
            </>
        )
    } // end of ComponentLeftTitleAndMessage

    /*===========================================
    summary: Title 顯示Component
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function ComponentTitle() 
    {   
        return(
            <div className={cssAssignReport.divTitle}>
                {window.gAppUI.LBL_AssignReport}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: 離開按鈕 顯示Component
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function ComponentBackButton() 
    {   
        return(
            <div className={cssAssignReport.btnBack} onClick={() => BackOnTapHandler()}/>
        )
    } // end of ComponentBackButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render AssignmentAnswerWindow 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderAssignmentAnswerWindowWrapper(StateIsShowAssignmentAnswerWindow)
    {
        if (StateIsShowAssignmentAnswerWindow)
        {
            return(
                <AssignmentAnswerWindow AssignmentData={mobjShowComponentParam.AssignmentData}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderAssignmentAnswerWindowWrapper

    /*===========================================
    summary: Render BulletinMsgBox 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderBulletinMsgBoxWrapper(StateIsShowBulletinMsgBox)
    {
        if (StateIsShowBulletinMsgBox)
        {
            return(
                <BulletinMsgBox Message={mobjShowComponentParam.Message}
                    CallbackRef={ComponentCallback}/>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderBulletinMsgBoxWrapper

    /*===========================================
    summary: Render 學生考卷列表 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderScoreListWrapper(ScoreData, ScoreIndex)
    {
        return (
            <>
                <ComponentScoreNameValueCell UserName={ScoreData.UserName}/>
                <ComponentScoreScoreValueCell Score={ScoreData.Score}/>
                <ComponentScoreStatusValueCell ScoreData={ScoreData} ScoreIndex={ScoreIndex}/>
            </>
        )
    } // end of RenderScoreListWrapper

    /*===========================================
    summary: Render 下方 子內容區域 的顯示
    remarks: 000 Tim 2021/11/12 Create
    ===========================================*/
    function RenderBottomSubContentWrapper()
    {
        return(
            <div className={cssAssignReport.divBottomSubContent}>
                <ComponentScoreTitleRow />
                
                <div className={cssAssignReport.divValueContent}>
                    {marrScoreData4List.map((ScoreData, ScoreIndex) =>
                        <div key={ScoreIndex} className={cssAssignReport.divValueRow}>
                            {RenderScoreListWrapper(ScoreData, ScoreIndex)}
                        </div>
                    )}
                </div>
            </div>
        )
    } // end of RenderBottomSubContentWrapper

    /*===========================================
    summary: Render 右上方 子子內容區域 的顯示
    remarks: 000 Tim 2020/11/12 Create
    ===========================================*/
    function RenderRightSubSubContentWrapper()
    {
        return (
            <div className={cssAssignReport.divRightSubSubContent}>
                <div className={cssAssignReport.divCompletionContent}>
                    <RunningPieChart Percentage={percentage4RPC} 
                        ScoredCount={mobjRPC.ScoredCount} 
                        ListCount={mobjRPC.ListCount} />
                </div>

                <ComponentAverageContent AvgScore={mobjDisplay.AvgScoreFormatted} />
            </div>
        )
    } // end of RenderRightSubSubContentWrapper

    /*===========================================
    summary: Render 左上方 日期區域 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderDataAreaWrapper()
    {
        return (
            <div className={cssAssignReport.divDataArea}>
                <ComponentDateTitleArea Title={window.gAppUI.LBL_StartDate} />

                <ComponentDateContent Date={mobjDisplay.StartDate} 
                    Time={mobjDisplay.StartTime} />

                <ComponentDelimiter />
                
                <ComponentDateTitleArea Title={window.gAppUI.LBL_DueDate} />
                
                <ComponentDateContent Date={mobjDisplay.DueDate} 
                    Time={mobjDisplay.DueTime} />
            </div>
        )
    } // end of RenderDataAreaWrapper

    /*===========================================
    summary: Render 左上方 子子內容區域 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderLeftSubSubContentWrapper()
    {
        return (
            <div className={cssAssignReport.divLeftSubSubContent}>
                <ComponentLeftTitleAndMessage Title={mstrLeftSubSubTitle} Message={mobjDisplay.AssigmentInfoMsg}/>

                <div className={cssAssignReport.divNameLine}/>

                {RenderDataAreaWrapper()}
            </div>
        )
    } // end of RenderLeftSubSubContentWrapper

    /*===========================================
    summary: Render TopSubContent 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderTopSubContentWrapper()
    {
        return(
            <div className={cssAssignReport.divTopSubContent}>
                {RenderLeftSubSubContentWrapper()}

                {RenderRightSubSubContentWrapper()}
            </div>
        )
    } // end of RenderTopSubContentWrapper

    /*===========================================
    summary: Render TopTool 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <>
                <ComponentBackButton />
                <ComponentTitle/>
            </>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignReport.divContent}>
                    {RenderTopSubContentWrapper()}
                    {RenderBottomSubContentWrapper()}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/11 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <>
                <div className={cssAssignReport.divBG}>
                    {RenderTopToolWrapper()}
                    {RenderContentWrapper(updateDataTime)}
                </div>

                {RenderBulletinMsgBoxWrapper(isShowBulletinMsgBox)}

                {RenderAssignmentAnswerWindowWrapper(isShowAssignmentAnswerWindow)}
            </>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignReport